<!--
 * @Author: 底部导航栏
 * @Date: 2020-07-28 10:31:12
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 11:43:06
 * @FilePath: \car-demo\src\components\Tabbar.vue
-->

<template>

  <div>
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="tabbar two">
      <!-- <template v-if="tabbarData.length == 2"></template> -->
      <a
          class="tabbar-item"
          href="javascript:;"
          v-for="(item, index) in footerTabBar"
          @click="clickTabBar(item)"
          :key="index"
          :class="{ center: item.center && item.is_enlarge == 1,fangda:item.is_enlarge==1 ,active: item.ad_key === $route.name }"
      >
        <img :src="item.ad_key === $route.name ? item.active_icon : item.icon" class="icon">
        <p>{{ item.menu_name }}</p>
      </a>
    </div>
  </div>
</template>

<script>
import cache from "../utils/cache";
import Vue from "vue";
import App from "../App";

export default {
  name: 'tabbar',
  data() {
    return {
      footerTabBar: [],
    }
  },
  created() {
	  if(!this.$ajax.get_activity_id()){
		  this.$router.push({name:'Empty',query:{'error':'活动不存在'}});
	  }else {
		  this.getFooterTabBar();//底部导航
	  }
      if(this.$parent.title == '车之驭'){
        this.titleInit();
      }
  },
  computed: {
    isOdd() {
      return this.tabbarData.length % 2 !== 0
    },
    centerIndex() {
      if (this.isOdd) {
        return Math.floor(this.tabbarData.length / 2)
      } else {
        return -1
      }
    },
    tabbarDataComputed() {
      let copy = JSON.parse(JSON.stringify(this.tabbarData))
      if (this.centerIndex !== -1) {
        copy[this.centerIndex].center = true
      }
      return copy
    },
  },
  methods: {
    getFooterTabBar() {
      //缓存倒 session 中,关闭页面从新打开才从后台获取数据
      let bars = cache.get('footer_bar');
      if (bars) {
        this.footerTabBar = JSON.parse(bars);

      } else {
        this.$ajax.get('m/system/get_footer_menu', {
          activity_id: this.$ajax.get_activity_id(),
        }).then(res => {
          this.footerTabBar = res;
          if (res && res.length) {
            cache.set('footer_bar', JSON.stringify(res));
          }
        })
      }
    },
    clickTabBar(item) {
      //无链接,点击直接返回
      console.log(item)
      if (item.link_type === 'no_link') return

      if (item.link_type === 'web_app') {
        window.location.href = item.menu_link;
        return
      }

      //app 直接跳转到内页
      if (item.link_type === 'app') {
        var host = window.location.host;
        if(item.ad_key.indexOf("maintain") != -1){
            window.location.href = 'http://'+host+'/'+item.ad_key+'/#/';
        }else if(item.ad_key.indexOf("businessList") != -1){
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
        }else{
          let query = {
            activity_id: this.$ajax.get_activity_id(),
            id: item.menu_link,
          }
          const currentDddress = this.$route.name;
          if(currentDddress == item.ad_key){
            //当前地址重复直接刷新页面,用route跳转会报错
            window.location.reload();
          }else {
            this.$router.push({name: item.ad_key, query: query})
          }
        }
        
      }
    },
    titleInit(){
      let activityInfo = cache.get('_activityInfo');
      if (!activityInfo) {
        this.$ajax.get('m/trade/get_activity_basic_info', {
          activity_id: this.$ajax.get_activity_id(),
        }).then((res) => {
          activityInfo = res
          this.$parent.title = activityInfo.title;
          cache.set('_activityInfo', res)
        })
      }else {
        this.$parent.title = JSON.parse(activityInfo).title;
      }
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  padding-bottom: 80px;
}

.tabbar {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  border-top: 1px solid #eaeaea;

  &-item {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    color: #666666;
    position: relative;
    height: 60px;
    .icon {
      width: 24px;
      height: 24px;
    }
  }
}
.active p{
  color: #3c43ec ;
  font-weight: bold;
}
.two {
  height: 60px;
}
.tabbar-item.fangda:after{
  content: " ";
  display: block;
  width: 74px;
  height: 74px;
  background-color: #ffffff;
  position: absolute;
  left: 50%;
  margin-left: -37px;
  top:0;
  z-index: 998;
  box-sizing: border-box;
}
.tabbar-item.fangda:before{
  content: " ";
  display: block;
  width: 70px;
  height: 70px;
  border: 1px solid #eaeaea;
  background-color: #ffffff;
  position: absolute;
  left: 50%;
  margin-left: -35px;
  top:-15px;
  border-radius: 100%;
  z-index: 997;
  box-sizing: border-box;

}
.tabbar-item.fangda p{
  position: relative;
  z-index: 999;
}
.tabbar-item.fangda img{
  position: relative;
  z-index: 999;
  top: -10px;
  transform: scale(1.2);
}
</style>
